export default "var a = 1;\nvar b = 2;\nconsole.log(a);\nconsole.log(b);\n\nconsole.log(a + b);\n";